import TagManager, { DataLayerArgs } from 'react-gtm-module'

export type AnalyticsRecord = Required<DataLayerArgs>['dataLayer']

export interface Analytics {
  dataLayer(record: AnalyticsRecord): void
}

const gtmAnalytics: Analytics = {
  dataLayer: (record: DataLayerArgs) =>
    TagManager.dataLayer({ dataLayer: record }),
}

export default gtmAnalytics
